module.exports = __webpack_public_path__ + "img/state12.481978e8.png";